var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: false, expression: "false" }
      ],
      staticClass: "order-print-table"
    },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { id: "out-table", data: _vm.orderTableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "50" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "created_at", label: "推送日期", width: "120" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "out_ware_day", label: "要求发货日" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "main_number", label: "主订单号", width: "110" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "total_price", label: "订单总金额", width: "110" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "total_amount", label: "订购总量", width: "135" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "total_send_amount",
              label: "实发总量",
              width: "135"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "box_num", label: "打包箱数", width: "300" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "weight", label: "总称重(kg)" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "od_statusName", label: "状态" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "user_name", label: "客户" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "print_num", label: "已打印次数" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9a5d3164", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a5d3164","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/order-print-table.vue
// module id = null
// module chunks = 